import * as React from 'react'
import { Typography, Stack } from '@mui/material'
import useEventStore from 'Store/eventStore'
import Moment from 'Components/Moment/Moment'

interface Props {}
const Hero: React.FC<Props> = () => {
      const event = useEventStore((state) => state.event)
      if (!event) return null
      return (
            <Stack spacing={1} sx={{ alignItems: 'center' }}>
                  <Typography variant="h1" className="eventTitle">
                        {event.title}
                  </Typography>
                  <Typography
                        className="logo"
                        sx={{
                              padding: '0!important',
                              margin: '0!important',
                              width: '100%',
                        }}
                  ></Typography>
                  <Typography
                        variant="body2"
                        className="eventDate"
                        sx={{ textTransform: 'capitalize' }}
                  >
                        {event.type} · <Moment date={event.date} />
                  </Typography>
            </Stack>
      )
}
export default Hero
